// @flow

import type {Language, PortfolioState} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Success, Failure} from 'folktale/validation'
import {isEmpty, merge, map, contains, values, flatten, clone, mergeAll} from 'ramda'
import {formActions, portfoliosActions, portfoliosSelectors, appSelectors} from '@/store'
import {buildBasePortfolioData} from '@/store/portfolio-data'
import {nonEmptyString, validateObject} from '@/validation'

import EditField from '@/controls/edit-field'
import ToggleButton from '@/controls/toggle-button'
import EmailAdder from './email-adder'

import './index.css'

type Props = {
  l: Language,
  id: ?string,
  activePortfolio: PortfolioState,
  setFormData: (?Object) => void,
  isActivePortfolioShared: boolean,
  activePortfolioPermissions: string,
  getPortfolioData: () => void,
}

const isEmail = (value) => /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)

const atLeastOne = (value) =>
  isEmpty(value)
    ? Failure(['You must provide at least one email address.'])
    : checkAllEntries(value)

const checkEntry = (obj) => !isEmail(obj.emailAddress)

const checkAllEntries = (data) => {
  var arr = map(checkEntry, data)
  var list = flatten(arr)
  return contains(true, values(list)) ? Failure(['must have value.']) : Success(data)
}

const validators = {
  name: [nonEmptyString('Portfolio Name')],
  emails: [atLeastOne],
  emailSubject: [nonEmptyString('Email subject line')],
}

export class RawPortfolioForm extends Component<Props, *> {
  constructor (props: Props) {
    super(props)

    this.state = merge(buildBasePortfolioData(), {isDefaultPortfolio: false})
  }

  componentDidMount () {
    if (this.props.id) {
      this.props.getPortfolioData()
    }
  }

  loadPortfolioData = (activePortfolio: Object) => {
    const p = activePortfolio
    const fields = {
      name: p.name,
      isDefault: p.isDefault || false,
      emails: clone(p.emails),
      emailSubject: p.emailSubject,
      isDefaultPortfolio: p.isDefault || false,
    }
    this.setState(fields)
  }

  update = (field: string) => (data: any) => {
    this.setState({
      [field]: data,
    }, () => {
      validateObject(validators, this.state)
        .fold(
          () => this.props.setFormData(null),
          this.props.setFormData
        )
    })
  }
  delEmail = (i: number) => {
    let list = this.state.emails
    list.splice(i, 1)
    this.setState({
      emails: list,
    }, () => {
      this.update('emails')(list)
    })
  }

  render = () =>
    <form>
      <div className="row">
        <div className="col-xs-4">
          <EditField
            label={`${this.props.l('Portfolio Name')} *`}
            value={this.state.name}
            validators={validators['name']}
            onChange={this.update('name')}
            disable={this.props.id && this.props.isActivePortfolioShared}
          />
        </div>
        <div className="col-xs-4">
          <EditField
            label={`${this.props.l('Email subject line')} *`}
            value={this.state.emailSubject}
            placeholder='Notifications'
            validators={validators['emailSubject']}
            onChange={this.update('emailSubject')}
          />
        </div>
        <div className="col-xs-4 checkbox-block">
          <ToggleButton
            label={this.props.l('Default portfolio')}
            value={this.state.isDefault}
            checked={this.state.isDefault}
            onChange={this.update('isDefault')}
            isDisabled={this.state.isDefaultPortfolio || (this.props.id && this.props.isActivePortfolioShared)}
          />
        </div>
        <div className="col-xs-12">
          <EmailAdder
            label={`${this.props.l('Emails')} *`}
            entries={this.state.emails}
            validators={validators['emails']}
            onChange={this.update('emails')}
            delEmail={this.delEmail}
          />
        </div>
      </div>
    </form>

  componentWillReceiveProps = (nextProps: Props) => {
    if (nextProps.id) {
      this.loadPortfolioData(nextProps.activePortfolio)
    }
  }
}

const mapStateToProps = (state) => ({
  activePortfolio: portfoliosSelectors.getActivePortfolio(state),
  l: appSelectors.getL(state),
  isActivePortfolioShared: portfoliosSelectors.isActivePortfolioShared(state),
  activePortfolioPermissions: portfoliosSelectors.getActivePortfolioPermissions(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, formActions])
)(RawPortfolioForm)



// WEBPACK FOOTER //
// ./src/views/forms/portfolio/index.js